module.exports = __webpack_public_path__ + "static/media/11.ee4c0b8b.jpg";